import IconRevenue from "../../assets/image/menubar/icon-revenue.svg";
import IconCost from "../../assets/image/menubar/icon-cost.svg";
import IconExpenses from "../../assets/image/menubar/icon-expenses.svg";
import IconBudget from "../../assets/image/menubar/icon-budget.svg";

export const SideBarMenu = [
  {
    name: "Revenue & Income",
    image: IconRevenue,
    link: "/dashboard/revenue-income",
    shortcutLink: "/dashboard/revenue-income",
    categories: [
      {
        name: "One Plan",
        link: "/dashboard/revenue-income/oneplan",
      },
      {
        name: "Max Plan",
        link: "/dashboard/revenue-income/maxplan",
      },
      {
        name: "Share Plan",
        link: "/dashboard/revenue-income/shareplan",
      },
    ],
  },
  {
    name: "Cost of Goods Sold",
    image: IconCost,
    link: "/dashboard/agentcommission",
    sublink: "/dashboard/agentcommission/detail/oneplan",
    shortcutLink: "/dashboard/agentcommission/detail/oneplan",
    categories: [
      {
        name: "Agent's Commission",
        path: "/dashboard/agentcommission/detail",
        plan: [
          {
            name: "One Plan",
            link: "/dashboard/agentcommission/detail/oneplan",
          },
          {
            name: "Max Plan",
            link: "/dashboard/agentcommission/detail/maxplan",
          },
          {
            name: "Share Plan",
            link: "/dashboard/agentcommission/detail/shareplan",
          },
        ],
      },
      {
        name: "Other Amounts",
        link: "/dashboard/agentcommission/others",
        shortcutLink: "/dashboard/agentcommission/others",
      },
    ],
  },
  {
    name: "Expenses",
    link: "/dashboard/expenses",
    image: IconExpenses,
  },
  {
    name: "Budget",
    link: "/dashboard/budget",
    image: IconBudget,
    shortcutLink: "/dashboard/budget",
  },
];
